import React from "react";

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="13" height="13">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const ChevronDownIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="13" height="13">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

function PackageSelectionCard({ package: pkg, isSelected, onSelect, isCustom = false, discountPercent = 0 }) {
  const [expanded, setExpanded] = React.useState(false);

  const originalPrice = pkg.price || 0;
  const discountedPrice = Math.round(originalPrice * (1 - discountPercent / 100));
  const hasDiscount = discountPercent > 0;
  const benefits = Array.isArray(pkg.benefits) ? pkg.benefits : [];

  return (
    <div
      onClick={onSelect}
      style={{
        border: `2px solid ${isSelected ? "var(--brand-500)" : "var(--border-subtle)"}`,
        borderRadius: 14,
        background: isSelected ? "var(--brand-50)" : "#fff",
        cursor: "pointer",
        transition: "all 0.15s ease",
        overflow: "hidden",
        marginBottom: 10,
      }}
    >
      {/* Card header row */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px" }}>
        {/* Radio indicator */}
        <div style={{
          width: 18, height: 18, borderRadius: "50%", flexShrink: 0,
          border: `2px solid ${isSelected ? "var(--brand-500)" : "var(--border-strong)"}`,
          background: isSelected ? "var(--brand-500)" : "#fff",
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all 0.15s ease",
        }}>
          {isSelected && <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#fff" }} />}
        </div>

        {/* Name + badge */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
            <span style={{ fontSize: 14, fontWeight: 600, color: "var(--text-strong)" }}>{pkg.name}</span>
            {isCustom && (
              <span style={{ fontSize: 11, fontWeight: 600, padding: "1px 7px", borderRadius: 99, background: "#f3f0ff", color: "#6d28d9" }}>Custom</span>
            )}
            {hasDiscount && (
              <span style={{ fontSize: 11, fontWeight: 600, padding: "1px 7px", borderRadius: 99, background: "var(--danger-50)", color: "var(--danger-600)" }}>-{discountPercent}%</span>
            )}
          </div>
        </div>

        {/* Price */}
        <div style={{ textAlign: "right", flexShrink: 0 }}>
          {hasDiscount ? (
            <>
              <div style={{ fontSize: 11, color: "var(--text-muted)", textDecoration: "line-through", lineHeight: 1.2 }}>
                Rp {originalPrice.toLocaleString("id-ID")}
              </div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "var(--danger-600)", lineHeight: 1.2 }}>
                Rp {discountedPrice.toLocaleString("id-ID")}
              </div>
            </>
          ) : (
            <div style={{ fontSize: 14, fontWeight: 700, color: "var(--brand-600)" }}>
              Rp {originalPrice.toLocaleString("id-ID")}
            </div>
          )}
          <div style={{ fontSize: 11, color: "var(--text-muted)" }}>/ bulan</div>
        </div>

        {/* Checkmark or chevron */}
        {benefits.length > 0 && (
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v); }}
            style={{
              flexShrink: 0, background: "none", border: "none", cursor: "pointer",
              color: "var(--text-muted)", display: "flex", alignItems: "center", padding: 2,
              transform: expanded ? "rotate(180deg)" : "none", transition: "transform 0.15s",
            }}
          >
            <ChevronDownIcon />
          </button>
        )}
      </div>

      {/* Benefits (expandable) */}
      {benefits.length > 0 && expanded && (
        <div style={{ padding: "0 16px 14px 46px", borderTop: "1px solid var(--border-subtle)" }}>
          <div style={{ paddingTop: 10, display: "flex", flexDirection: "column", gap: 5 }}>
            {benefits.map((b, i) => (
              <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 7, fontSize: 12.5, color: "var(--text-base)" }}>
                <span style={{ color: "var(--success-500)", flexShrink: 0, marginTop: 1 }}><CheckIcon /></span>
                {b}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default PackageSelectionCard;
